import articles from '@/mockData/wiki.articles.json'
import wikiService from "@/services/api/wiki.services";



const state = {
    list: articles,
    wikiCategories: [],
}

const mutations = {
    ADD_ARTICLE(state, payload) {
        state.list.push(payload)
    },
    SET_WIKI_CATEGORIES(state, payload) {
        state.wikiCategories = payload || []
    }
}

const actions = {
    getArticleById(articleId) {
        return state.list.find(item => item.id == articleId)
    },
    addArticle({ commit }, form) {
        commit('ADD_ARTICLE', form)
    },

    getWiki(context, payload = {}) {
        return new Promise((resolve, reject) => {
            const config = {}
            if (payload.search != null && String(payload.search).trim() !== '') {
                config.params = { search: String(payload.search).trim() }
            }
            wikiService.getWiki(config)
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },

    getWikiCategories({ commit }) {
        return new Promise((resolve, reject) => {
            wikiService.getWikiCategories()
                .then((response) => {
                    const data = response.data?.data ?? response.data ?? []
                    commit('SET_WIKI_CATEGORIES', Array.isArray(data) ? data : [])
                    resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    createWikiCategory({ dispatch }, payload) {
        return wikiService.createWikiCategory(payload).then((response) => {
            return dispatch('getWikiCategories').then(() => response)
        })
    },

    updateWikiCategory({ dispatch }, { id, ...payload }) {
        return wikiService.updateWikiCategory(id, payload).then(() => dispatch('getWikiCategories'))
    },

    deleteWikiCategory({ dispatch }, id) {
        return wikiService.deleteWikiCategory(id).then(() => dispatch('getWikiCategories'))
    },
// eslint-disable-next-line
    addNewPost({ commit }, payload) {
        return new Promise((resolve, reject) => {
            wikiService.post('wiki', {}, payload, {
                headers: {
                    Accept: "application/json",
                    // "Content-Type": "multipart/form-data",
                },
            }) .then(() => {
                wikiService.get('wiki')
                    .then((response) => {
                        return resolve(response)
                    })
                    .catch((error) => reject(error))
            }
            ).catch((error) => reject(error))
        })
    },

    deletePost(context, id) {
        return new Promise((resolve, reject) => {
            wikiService.delete('deletePost', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
// eslint-disable-next-line
    updatePost({ commit }, form) {
        return new Promise((resolve, reject) => {
            wikiService.updateTopic(
                form.id,
                form.payload
            )
                .then((response) => {return resolve(response)})
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getData: state => state.list,
    getArticleInfo: state => id => state.list.find(item => Number(item.id) === Number(id)),
    getWikiCategories: state => state.wikiCategories,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
